import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

interface Props {
  caseId: string;
}
export function ActivityTypeFilter(props: Props) {
  const { caseId } = props;
  const { setParam, params } = useQueryParams();
  const { data } = useClientPortalAPI(
    `/api/internal/client-portal/case/${caseId}/activity-type/options/`
  );
  const { t } = useTranslation();

  useEffect(() => {
    setParam("activity_type", ["CASE", "NOTIFICATION"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const pickerItems = data?.results
    .map(
      (type: {
        activity_type: {
          name: string;
          label: string;
        };
      }) => {
        return { id: type.activity_type.name, name: type.activity_type.label };
      }
    )
    .sort((a: { name: string }, b: { name: string }) =>
      a.name.localeCompare(b.name)
    );

  return (
    <Picker
      label={t("Activity type")}
      items={pickerItems}
      selectedKeys={params.activity_type?.split(",")}
      onSelectionChange={(keys) => setParam("activity_type", Array.from(keys))}
      selectionMode="multiple"
      showActionBar
      testID="activity-type-picker"
    />
  );
}
